
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 import { SkyDivider as SkyDividerElement } from '@sky.ui/core/sky-divider';
 
 
 
 

 
 export const SkyDivider = createComponent({
   displayName: 'SkyDivider',
   react: React,
   tagName: 'sky-divider',
   elementClass: SkyDividerElement,
   events: {
     
   }
  });
export type * from '@sky.ui/core/sky-divider';
